import React from 'react';
import './PdfViewer.css';
import backgroundVideo from "../../assets/frontvideo2.mp4"; // Place this video in the public folder or src


// Static imports for each PDF file
import pdf2011Paper from './2011 IMAT Exam.pdf';
import pdf2011AnswerKey from './2011 IMAT Answer Key.pdf';
import pdf2012Paper from './2012 IMAT Exam.pdf';
import pdf2012AnswerKey from './2012 IMAT Answer Key.pdf';
import pdf2013Paper from './2013 IMAT Exam.pdf';
import pdf2013AnswerKey from './2013 IMAT Answer Key.pdf';
import pdf2014Paper from './2014 IMAT Exam.pdf';
import pdf2014AnswerKey from './2014 IMAT Answer Key.pdf';
import pdf2015Paper from './2015 IMAT Exam.pdf';
import pdf2015AnswerKey from './2015 IMAT Answer Key.pdf';
import pdf2016Paper from './2016 IMAT Exam.pdf';
import pdf2016AnswerKey from './2016 IMAT Answer Key.pdf';
import pdf2017Paper from './2017 IMAT Exam.pdf';
import pdf2017AnswerKey from './2017 IMAT Answer Key.pdf';
import pdf2018Paper from './2018 IMAT Exam.pdf';
import pdf2018AnswerKey from './2018 IMAT Answer Key.pdf';
import pdf2019Paper from './2019 IMAT Exam.pdf';
import pdf2019AnswerKey from './2019 IMAT Answer Key.pdf';
import pdf2020Paper from './2020 IMAT Exam.pdf';
import pdf2020AnswerKey from './2020 IMAT Answer Key.pdf';
import pdf2021Paper from './2021 IMAT Exam.pdf';
import pdf2021AnswerKey from './2021 IMAT Answer Key.pdf';
import pdf2022Paper from './2022 IMAT Exam.pdf';
import pdf2022AnswerKey from './2022 IMAT Answer Key.pdf';
import pdf2023Paper from './2023 IMAT Exam.pdf';
import pdf2023AnswerKey from './2023 IMAT Answer Key.pdf';
import pdf2024Paper from './2024 IMAT Exam.pdf';
import pdf2024AnswerKey from './2024 IMAT Answer Key.pdf';

// Object to map years to their respective PDF files
const pdfFiles = {
  2011: {
    paper: pdf2011Paper,
    answerKey: pdf2011AnswerKey,
  },
  2012: {
    paper: pdf2012Paper,
    answerKey: pdf2012AnswerKey,
  },
  2013: {
    paper: pdf2013Paper,
    answerKey: pdf2013AnswerKey,
  },
  2014: {
    paper: pdf2014Paper,
    answerKey: pdf2014AnswerKey,
  },
  2015: {
    paper: pdf2015Paper,
    answerKey: pdf2015AnswerKey,
  },
  2016: {
    paper: pdf2016Paper,
    answerKey: pdf2016AnswerKey,
  },
  2017: {
    paper: pdf2017Paper,
    answerKey: pdf2017AnswerKey,
  },
  2018: {
    paper: pdf2018Paper,
    answerKey: pdf2018AnswerKey,
  },
  2019: {
    paper: pdf2019Paper,
    answerKey: pdf2019AnswerKey,
  },
  2020: {
    paper: pdf2020Paper,
    answerKey: pdf2020AnswerKey,
  },
  2021: {
    paper: pdf2021Paper,
    answerKey: pdf2021AnswerKey,
  },
  2022: {
    paper: pdf2022Paper,
    answerKey: pdf2022AnswerKey,
  },
  2023: {
    paper: pdf2023Paper,
    answerKey: pdf2023AnswerKey,
  },
  2024: {
    paper: pdf2024Paper,
    answerKey: pdf2024AnswerKey,
  },
};

function PdfViewer() {
  return (
    <>
     <div className="hero-container">
            <video autoPlay loop muted className="background-video">
              <source src={backgroundVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <div className="hero-content">
              <h1>Welcome to Future MedsAcademy – Your Ultimate IMAT Preparation Hub!
              </h1>
              <div className="hero-buttons">
                <button
                  className="join-btn"
                  id="loginBtn"
                  onClick={() => (window.location.href = 'https://mocktest.futuremedsacademy.com/')}
                >
                  Join Us
                </button>
                <button className="whats-new-btn">WHAT'S NEW</button>
              </div>
            </div>
          </div>

          <div className="future-meds-academy">
      <h1>Welcome to Future MedsAcademy </h1><h1> Your Ultimate IMAT Preparation Hub!</h1>
      <p>
        At Future MedsAcademy, we are dedicated to helping aspiring medical students achieve their dreams of studying medicine in Italy. With over 13 years of IMAT past papers, expert-led courses, and comprehensive study resources, we provide everything you need to ace the International Medical Admissions Test (IMAT) and secure your place in top medical schools.
      </p>

      <h2>Why Choose Future MedsAcademy?</h2>
      <ul>
        <li>
          <strong>13+ Years of IMAT Past Papers:</strong> Access downloadable PDFs of IMAT question papers from 2012 to 2024, complete with detailed solutions.
        </li>
        <li>
          <strong>Expert Guidance:</strong> Learn from experienced tutors who have helped hundreds of students succeed in the IMAT.
        </li>
        <li>
          <strong>Personalized Study Plans:</strong> Tailored strategies to maximize your score in Biology, Chemistry, Physics, Math, and Logical Reasoning.
        </li>
        <li>
          <strong>Affordable Resources:</strong> High-quality study materials and courses at competitive prices.
        </li>
        <li>
          <strong>Scholarship Support:</strong> Get guidance on scholarships and financial aid for international students.
        </li>
      </ul>

      <p>
        Whether you're just starting your IMAT preparation or looking to fine-tune your skills, Future MedsAcademy is here to support you every step of the way. Join us today and take the first step toward your medical career!
      </p>

      <button className="join-button" onClick={() => (window.location.href = 'https://mocktest.futuremedsacademy.com/login')}>Join Us Today</button>
    </div>

      {Object.keys(pdfFiles).map((year) => (
        <div className="main-container" key={year}>
          {/* Centered h1 tag */}
          <h1 className="hai">IMAT {year} Past Paper PDF</h1>

          {/* Flex container for side-by-side divs */}
          <div className="flex-container">
            {/* div-1: Paper */}
            <div className="container">
              {/* PDF Preview */}
              <div className="pdf-preview">
                <iframe
                  src={pdfFiles[year].paper}
                  width="100%"
                  height="500px"
                  title={`${year} IMAT Exam Paper`}
                  style={{ border: 'none' }}
                ></iframe>
              </div>

              {/* PDF Actions */}
              <div className="pdf-actions">
                <a
                  href={pdfFiles[year].paper}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn"
                >
                  Open Paper
                </a>
                <a
                  href={pdfFiles[year].paper}
                  download={`${year} IMAT Exam.pdf`}
                  className="btn"
                >
                  Download Paper
                </a>
              </div>
            </div>

            {/* div-2: Answer Key */}
            <div className="container">
              {/* PDF Preview */}
              <div className="pdf-preview">
                <iframe
                  src={pdfFiles[year].answerKey}
                  width="100%"
                  height="500px"
                  title={`${year} IMAT Answer Key`}
                  style={{ border: 'none' }}
                ></iframe>
              </div>

              {/* PDF Actions */}
              <div className="pdf-actions">
                <a
                  href={pdfFiles[year].answerKey}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn"
                >
                  Open Key
                </a>
                <a
                  href={pdfFiles[year].answerKey}
                  download={`${year} IMAT Answer Key.pdf`}
                  className="btn"
                >
                  Download Key
                </a>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}

export default PdfViewer;